import React from "react";
import PropTypes from "prop-types";

import { withStyles } from "@material-ui/core/styles";
import { FormStyles } from "../../../../styles";
import { useTranslation } from 'react-i18next';

import Classnames from 'classnames'


const Form = props => {
  const { handleChange, classes, values, errors, touched, errorLogin, resetLoginErrors } = props;
  const { t } = useTranslation();

  return (
    <div >
      <h2 className="mb-4">{t('login.title')}</h2>
      <div className={Classnames("form-group", { "error-mess": errors.username && touched.username || errorLogin })}>
        <input type="text" className="form-control" id="ipt-identifiant"
          name="username"
          placeholder={t('login.username_placeholder')}
          onChange={(event) => { handleChange(event); resetLoginErrors(); }}
          value={values.username}
        />
        {errors.username && touched.username ? (
          <p >{errors.username}</p>
        ) : null}
      </div>
      <div className={Classnames("form-group", { "error-mess": errors.password && touched.password || errorLogin })}>
        <input type="password"
          name="password"
          className="form-control" id="ipt-password" placeholder={t('login.password_placeholder')}
          onChange={(event) => { handleChange(event); resetLoginErrors(); }}
          value={values.password}
        />
        {errors.password && touched.password ? (
          <p >{errors.password}</p>
        ) : null}
        {errorLogin ? (
          <p >{errorLogin}</p>
        ) : null}
      </div>
    </div >
  );
};

Form.propTypes = {
  handleChange: PropTypes.func,
  values: PropTypes.object,
  classes: PropTypes.object,
  errors: PropTypes.object
};

export default withStyles(FormStyles)(Form);
